// ── CONTEXTUAL TIP BAR (fp-nofodesk-9 follow-up) — extracted from App.js ──
import { FONT_UI } from "../theme";

function TipBar({ tip, onDismiss, onAction, T }) {
  if (!tip) return null;
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 12,
      padding: "9px 20px",
      background: T.bgElevated,
      borderBottom: `1px solid ${T.border}`,
      flexShrink: 0,
    }}>
      <span style={{ fontSize: 13, color: T.gold, flexShrink: 0 }}>💡</span>
      <span style={{ fontFamily: FONT_UI, fontSize: 13, color: T.textSub, flex: 1, lineHeight: 1.5 }}>{tip.text}</span>
      {tip.action && (
        <button
          onClick={onAction}
          style={{ background: "none", border: `1px solid ${T.border}`, borderRadius: 6, padding: "4px 12px", fontSize: 12, color: T.text, fontFamily: FONT_UI, cursor: "pointer", flexShrink: 0 }}
        >
          {tip.action.label}
        </button>
      )}
      <button
        onClick={onDismiss}
        style={{ background: "none", border: "none", color: T.textMuted, fontSize: 16, cursor: "pointer", lineHeight: 1, flexShrink: 0, padding: 0 }}
        title="Dismiss"
      >×</button>
    </div>
  );
}

export default TipBar;
